module.exports = __webpack_public_path__ + "static/media/beach-1.bee59b91.jpg";